import { useEffect } from 'react';
import { Layout, Menu, Avatar, Dropdown, Space } from 'antd';
import {
  HomeOutlined,
  ExperimentOutlined,
  AppstoreOutlined,
  UserOutlined,
  LogoutOutlined,
  PictureOutlined,
} from '@ant-design/icons';
import { Outlet, useLocation, useNavigate, Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth.store';
import { formatCents } from '@/utils/format';

const { Sider, Content, Header } = Layout;

const AuthLayout: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { creator, ready, loadSession, logout } = useAuthStore();

  useEffect(() => {
    if (!ready) loadSession();
  }, [ready, loadSession]);

  if (!ready) return null;
  if (!creator) return <Navigate to="/login" replace />;

  const selectedKey = location.pathname.split('/')[1] || 'home';

  const menuItems = [
    { key: 'home', icon: <HomeOutlined />, label: '个人首页' },
    { key: 'experiments', icon: <ExperimentOutlined />, label: '创作实验' },
    { key: 'bundles', icon: <AppstoreOutlined />, label: '组合套图' },
    { key: 'usage', icon: <PictureOutlined />, label: '套图调用' },
  ];

  return (
    <Layout hasSider style={{ minHeight: '100vh' }}>
      <Sider
        width={220}
        theme="light"
        style={{
          borderRight: '1px solid #F0EBDE',
          position: 'fixed',
          insetInlineStart: 0,
          top: 0,
          bottom: 0,
          height: '100vh',
          overflow: 'auto',
          zIndex: 10,
        }}
      >
        <div
          style={{
            height: 64,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderBottom: '1px solid #F0EBDE',
          }}
        >
          <span className="brand-logo">予人智图 · 创作者</span>
        </div>
        <Menu
          mode="inline"
          selectedKeys={[selectedKey]}
          items={menuItems}
          onClick={(e) => navigate(`/${e.key}`)}
          style={{ borderInlineEnd: 'none', paddingTop: 8 }}
        />
      </Sider>
      <Layout style={{ marginInlineStart: 220 }}>
        <Header
          className="creator-header"
          style={{
            padding: '0 28px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            gap: 12,
            height: 64,
          }}
        >
          <Space size={8}>
            <span className="balance-pill balance-pill--amber">
              <span className="balance-pill__dot" />
              实验金 {formatCents(creator.experimentBalanceCents)}
            </span>
            <span className="balance-pill balance-pill--green">
              <span className="balance-pill__dot" />
              收益 {formatCents(creator.earningsBalanceCents)}
            </span>
          </Space>
          <Dropdown
            menu={{
              items: [
                {
                  key: 'logout',
                  icon: <LogoutOutlined />,
                  label: '退出登录',
                  onClick: () => logout(),
                },
              ],
            }}
          >
            <Space style={{ cursor: 'pointer', marginLeft: 12 }}>
              <Avatar size="small" icon={<UserOutlined />} style={{ background: '#FEF3C7', color: '#B45309' }} />
              <span style={{ fontWeight: 500 }}>{creator.displayName || creator.email}</span>
            </Space>
          </Dropdown>
        </Header>
        <Content style={{ padding: '24px 28px', background: '#FBFAF7' }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default AuthLayout;
